
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { NotificationModel } from './Communication.Api.Models.Notification';
import { CommunicationLogEditModel } from './Communication.Api.Models.CommunicationLogEdit';
import { LogEntryType } from 'enums/LogEntryType';
import { Model, ModelProperty } from 'models/Model';


export class CommunicationLogEntryModel extends Model<CommunicationLogEntryModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'comment', type: 'string' },
		{ name: 'userId', type: 'string' },
		{ name: 'taskActionId', type: 'string' },
		{ name: 'taskflowId', type: 'string' },
		{ name: 'timestamp', type: 'Date' },
		{ name: 'modified', type: 'Date' },
		{ name: 'additionalData', type: 'string' },
		{ name: 'companyId', type: 'string' },
		{ name: 'notifications', type: 'NotificationModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new NotificationModel }, properties: () => { return NotificationModel.classProperties } },
		{ name: 'edits', type: 'CommunicationLogEditModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new CommunicationLogEditModel }, properties: () => { return CommunicationLogEditModel.classProperties } },
		{ name: 'statusType', type: 'string' },
		{ name: 'type', type: 'LogEntryType' },
		{ name: 'uniqueId', type: 'string' }
	];
	[key: string]: any;
	
	public id?: string;
	public comment: string;
	public userId?: string;
	public taskActionId?: string;
	public taskflowId?: string;
	public timestamp?: Date;
	public modified?: Date;
	public additionalData: string;
	public companyId?: string;
	public notifications: NotificationModel[];
	public edits: CommunicationLogEditModel[];
	public statusType: string;
	public type: LogEntryType;
	public uniqueId: string;
    
	constructor(){
		super();
		this.id = undefined;
		this.comment = '';
		this.userId = undefined;
		this.taskActionId = undefined;
		this.taskflowId = undefined;
		this.timestamp = undefined;
		this.modified = undefined;
		this.additionalData = '';
		this.companyId = undefined;
		this.notifications = [];
		this.edits = [];
		this.statusType = '';
		this.type = 0;
		this.uniqueId = '';
		
	}
	getProperties(){
		return CommunicationLogEntryModel.classProperties;
	}
}

